module.exports = __webpack_public_path__ + "img/store.529e53aa.png";